"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultAggregations = exports.aggregationDetailDictionary = void 0;
var _Functions = _interopRequireDefault(require("@mui/icons-material/Functions"));
var _Receipt = _interopRequireDefault(require("@mui/icons-material/Receipt"));
var _VerticalAlignBottom = _interopRequireDefault(require("@mui/icons-material/VerticalAlignBottom"));
var _VerticalAlignCenter = _interopRequireDefault(require("@mui/icons-material/VerticalAlignCenter"));
var _VerticalAlignTop = _interopRequireDefault(require("@mui/icons-material/VerticalAlignTop"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon/SvgIcon.js"));
var _react = _interopRequireDefault(require("react"));
var _visualTypes = require("../../types/visualTypes");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const aggregationDetailDictionary = exports.aggregationDetailDictionary = {
  [_visualTypes.Aggregation.AVERAGE]: {
    Icon: props => /*#__PURE__*/(0, _jsxRuntime.jsx)(LetterIcon, {
      ...props,
      children: "A"
    }),
    label: 'Average'
  },
  [_visualTypes.Aggregation.COUNT]: {
    Icon: props => /*#__PURE__*/(0, _jsxRuntime.jsx)(LetterIcon, {
      ...props,
      children: "C"
    }),
    label: 'Count'
  },
  [_visualTypes.Aggregation.COUNTU]: {
    Icon: props => /*#__PURE__*/(0, _jsxRuntime.jsx)(LetterIcon, {
      ...props,
      children: "U"
    }),
    label: 'Unique count'
  },
  [_visualTypes.Aggregation.MAX]: {
    Icon: _VerticalAlignTop.default,
    label: 'Maximum'
  },
  [_visualTypes.Aggregation.MEDIAN]: {
    Icon: _VerticalAlignCenter.default,
    label: 'Median'
  },
  [_visualTypes.Aggregation.MIN]: {
    Icon: _VerticalAlignBottom.default,
    label: 'Minimum'
  },
  [_visualTypes.Aggregation.NONE]: {
    Icon: _Receipt.default,
    label: 'None'
  },
  [_visualTypes.Aggregation.Q1]: {
    Icon: props => /*#__PURE__*/(0, _jsxRuntime.jsx)(LetterIcon, {
      ...props,
      children: "1"
    }),
    label: 'Quartile 1'
  },
  [_visualTypes.Aggregation.Q3]: {
    Icon: props => /*#__PURE__*/(0, _jsxRuntime.jsx)(LetterIcon, {
      ...props,
      children: "3"
    }),
    label: 'Quartile 3'
  },
  [_visualTypes.Aggregation.STDEV]: {
    Icon: props => /*#__PURE__*/(0, _jsxRuntime.jsx)(LetterIcon, {
      ...props,
      children: "S"
    }),
    label: 'Standard deviation'
  },
  [_visualTypes.Aggregation.SUM]: {
    Icon: _Functions.default,
    label: 'Sum'
  },
  [_visualTypes.Aggregation.UNKNOWN]: {
    Icon: _Receipt.default,
    label: 'Unknown'
  },
  [_visualTypes.Aggregation.VARIANCE]: {
    Icon: props => /*#__PURE__*/(0, _jsxRuntime.jsx)(LetterIcon, {
      ...props,
      children: "V"
    }),
    label: 'Variance'
  }
};
const defaultAggregations = exports.defaultAggregations = [_visualTypes.Aggregation.SUM, _visualTypes.Aggregation.AVERAGE, _visualTypes.Aggregation.MAX, _visualTypes.Aggregation.MIN, _visualTypes.Aggregation.COUNT];
function LetterIcon({
  children,
  ...rest
}) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SvgIcon.default, {
    ...rest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
      x: "12",
      y: "12",
      fontWeight: "bold",
      textAnchor: "middle",
      alignmentBaseline: "middle",
      children: children
    })
  });
}